import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from "antd";

const CustomPrompt = ({ when, message }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [nextLocation, setNextLocation] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const skipBlockRef = useRef(false);

  // Prevent reloads (optional)
  useEffect(() => {
    if (!when || confirmedNavigation) return;

    const handleBeforeUnload = (e) => {
      const msg = typeof message === "function" ? message(location) : message;
      e.preventDefault();
      e.returnValue = msg;
      return msg;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [when, confirmedNavigation, message, location]);

  // Intercept browser navigation changes
  useEffect(() => {
    if (!when || confirmedNavigation) return;

    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    const handlePushReplaceState = (method) => (...args) => {
      if (skipBlockRef.current) {
        skipBlockRef.current = false;
        return method.apply(window.history, args); // allow
      }

      const url = args[2];
      const a = document.createElement("a");
      a.href = url;

      const currentPath = window.location.pathname;
      const nextPath = a.pathname;
      const fullNextUrl = a.pathname + a.search;

      if (nextPath === currentPath) {
        return method.apply(window.history, args); // allow query change
      }

      const result = typeof message === "function" ? message({ pathname: nextPath }) : message;

      if (result === true) {
        method.apply(window.history, args);
      } else {
        setNextLocation(fullNextUrl);
        setModalMessage(result);
        setShowModal(true);
      }
    };

    // Patch history methods
    window.history.pushState = handlePushReplaceState(originalPushState);
    window.history.replaceState = handlePushReplaceState(originalReplaceState);

    return () => {
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, [when, confirmedNavigation, message]);

  const handleConfirm = () => {
    setShowModal(false);
    setConfirmedNavigation(true);
    skipBlockRef.current = true; //
    if (nextLocation) {
      navigate(nextLocation);
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setNextLocation(null);
  };

  return (
    <Modal
      open={showModal}
      title="Are you sure?"
      onOk={handleConfirm}
      onCancel={handleCancel}
      okText="Yes"
      cancelText="Cancel"
      closable={false}
      maskClosable={false}
      keyboard={false}
      styles={{ mask:{backdropFilter: 'blur(5px)'}}}
      mask={true}
    >
      {modalMessage}
    </Modal>
  );
};

export default CustomPrompt;